import "./App.scss"
import "./search.scss"
import "./lang.scss"
import allLang from "./utils/lang"
import React, { useState, useEffect, useRef } from "react"
import { Form, Input, Button, Checkbox, Row, Col, notification, Drawer } from "antd"
// import logoImg from "./images/logo@2x.png"
import newLogo from "./images/newLogo.png"
import airpLogo from "./images/airp__logo.png"
import { DownOutlined, LeftOutlined } from "@ant-design/icons"
import { postJson, getJson } from "./utils/fetch"
import { JSEncrypt } from "jsencrypt"

import { loginError, valicodeError, unregisteredresolve } from "./utils/index.js"
import config from "./const.js"
import { Link } from "react-router-dom"

let timeChange
const LoginForm = ({ onLoginSuccess }) => {
  const [form] = Form.useForm() //获取form实例
  let ref = useRef()
  const [lang, setLang] = useState("")
  const [clientId, setClientId] = useState("")
  const [clientIdList] = useState(['alice', 'vkplatform', 'vk_trouver', 'alice_trouver', 'sber', 'google', 'google_mova', 'd_airp_dueros', 'd_airp_alice', 'd_airp_alexa', 'd_airp_google'])
  const airpClientIds = ['d_airp_dueros', 'd_airp_alice', 'd_airp_alexa', 'd_airp_google']
  const isAirpClient = airpClientIds.includes(clientId)
  const [voiceType, setVoice] = useState("")
  const [account, setAccount] = useState("")
  const [country, setCountry] = useState("")
  const [password, setPassword] = useState("")
  const [showAccount, setShowAccount] = useState(false)
  const [checkFile, setCheckFile] = useState(false)
  const [phoneNumber, setPhoneNumber] = useState("")
  const [valideCode, setValideCode] = useState("")

  const [time, setTime] = useState(60)
  const [IP, setIP] = useState(false)
  const [btnDisabled, setBtnDisabled] = useState("none")
  const [isOnCliCK, setClick] = useState(true)
  const [isGetCaptcha, setIsGetCaptha] = useState(false)
  const [btnContent, setBtnContent] = useState("")
  const [code, setCode] = useState("")
  const [countryAndArea, setCountryAndArea] = useState("")
  const [chooseArea, chooseAreaCode] = useState(false)

  const [converCountryList, setConvertCountryList] = useState(config.countryList)
  const [countryList, setCountryList] = useState(config.countryList)
  const [langList, setlangList] = useState(config.langList)
  const [publicKey, savePublicKey] = useState("")
  const [codeKey, saveCodeKey] = useState("")
  const [initCountry, setInitCountry] = useState("")
  const [finalDomain, setDomainUrl] = useState("")
  const [finalDomainSmarthome, setDomainUrlSmarthome] = useState("")
  const [drawerVisible, setVisible] = useState(false)
  const [chooseLang, setChooseLang] = useState(false)
  const [chooseCountry, setChooseCountry] = useState(false)
  const [pageUrl, setPageUrl] = useState("")

  useEffect(() => {
    //缓存账号密码以及用户的选择(如果存在)
    const accountItem = sessionStorage.getItem("account")
    const passwordItem = sessionStorage.getItem("password")
    const phoneNumberItem = sessionStorage.getItem("phoneNumber") || ""
    const valideCodeItem = sessionStorage.getItem("valideCode")
    //获取浏览器默认语言来初始化
    let langDefault = (navigator.language || navigator.userLanguage).toLowerCase()
    let defaultLang = sessionStorage.getItem("localLang") || (langDefault === "zh-tw" || langDefault === "zh-hk" ? langDefault : langDefault.substr(0, 2))

    // 先获取 clientId，然后根据它设置默认国家
    let clientId = getQueryVariable("client_id") || ""
    let countryItem = 'RU'
    if (clientId === "google" || clientId === "google_mova") {
      countryItem = 'DE'
    }
    // Alexa 不支持俄罗斯，默认改为美国，列表中也不展示俄罗斯
    if (clientId === "d_airp_alexa") {
      countryItem = 'US'
      setCountryList(config.countryList.filter((item) => item.short !== "RU"))
    }

    if (accountItem) form.setFieldsValue({ account: accountItem })
    if (countryItem) form.setFieldsValue({ country: countryItem })
    if (passwordItem) form.setFieldsValue({ password: passwordItem })
    if (phoneNumberItem) {
      form.setFieldsValue({ phoneNumber: phoneNumberItem })
      setPhoneNumber(phoneNumberItem)
    }
    if (valideCodeItem) form.setFieldsValue({ valideCode: valideCodeItem })

    const langMap = {
      "zh": "zh", "en": "en", "ru": "ru", "zh-tw": "zh-tw", "zh-hk": "zh-hk",
      "de": "de", "ko": "ko", "ja": "ja", "fr": "fr", "es": "es", "it": "it",
      "pl": "pl", "tr": "tr", "th": "th", "vi": "vi", "id": "id", "uk": "uk"
    }
    convertLanguageLogic(langMap[defaultLang] || "en")
    convertCountryLogic(countryItem)
    getClientId()

    if (defaultLang) {
      let url = decodeURIComponent(window.location.search)
      setPageUrl(url)
      // 获取 url 中的 client_id
      const urlParams = new URLSearchParams(window.location.search);
      const urlClientId = urlParams.get('client_id');
      const domainMap = {
        "aligenie": { voice: "cat" },
        "dueros": { voice: "xiaodu" },
        "aqara": { voice: "aqara" },
        "alexa": { voice: "Alexa" },
        "google": { voice: "google" },
        "alice": { voice: "Alice" },
        "sber": { voice: "sber" },
        "moorgen": { voice: "moorgen" },
        "vkplatform": { voice: "vk" },
        "hornbach": { voice: "hornbach" },
        "leelen": { voice: "leelen" },
        "chinaMobile": { voice: "chinaMobile" },
        "morelinks": { voice: "morelinks" },
        "hdl": { voice: "hdl" },
        "mihome": { voice: "mihome" },
        "iwith": { voice: "iwith" },
        "honor": { voice: "honor" },
        "d_airp_dueros": { voice: "d_airp_dueros" },
        "d_airp_alice": { voice: "d_airp_alice" },
        "d_airp_alexa": { voice: "d_airp_alexa" },
        "d_airp_google": { voice: "d_airp_google" }
      }
      // 如果 clientId 是 honor，直接设置 voiceType
      if (clientId === "honor") {
        if (allLang[defaultLang] && allLang[defaultLang].honor) {
          setVoice(allLang[defaultLang].honor)
        } else {
          setVoice(allLang['en'].honor)
        }
      } else {
        let key = Object.keys(domainMap).find(key => {
          return urlClientId === key
        })
        if (key) {
          if (allLang[defaultLang]) {
            setVoice(allLang[defaultLang][domainMap[key].voice])
          } else {
            setVoice(allLang['en'][domainMap[key].voice])
          }
        }
      }
      setDomainUrl('/dreame-auth/')
      setDomainUrlSmarthome('/dreame-smarthome/')
      initPage('/dreame-auth/', defaultLang, phoneNumberItem)
    }
  }, [])

  //根据语言
  const convertLanguageLogic = (lang) => {
    setLang(lang)
    setBtnContent(allLang[lang].getCode)
  }

  // 设置国家 
  const convertCountryLogic = (conutry) => {
    setCountry(conutry)
  }
  const getClientId = () => {
    let clientId = getQueryVariable("client_id") || ""
    setClientId(clientId)
  }
  //切换语言 变换页面
  const changeLang = () => {
    setChooseLang(true)
  }

  useEffect(() => {
    clearInterval(timeChange)
    return () => clearInterval(timeChange)
  }, [])

  useEffect(() => {
    console.log(time)
    if (time > 0 && time < 60) {
      // setBtnContent('已发送')
      setBtnContent(lang ? `${time}${allLang[lang].second}` : "")
    } else {
      clearInterval(timeChange)
      setBtnDisabled("auto")
      setTime(60)
      setBtnContent(lang ? `${allLang[lang].getCode}` : "")
    }
  }, [time])

  const initPage = (url, defaultLang, phoneNumberItem) => {
    postJson(url + "publickey").then((res) => {
      // console.log(res.data)
      if (res.data) {
        savePublicKey(res.data)
      }
    })
    getJson(url + "countryCode").then((res) => {
      if (res.success == true) {
        //根据返回的jp 找到对应的手机码
        let simpleCountry = res.data
        setInitCountry(simpleCountry)
        if (simpleCountry === "CN") {
          //国内校验
          if (phoneNumberItem.length === 11 && phoneNumberItem.charAt(0) == 1) {
            setClick(false)
            setBtnDisabled("auto")
          } else {
            setClick(true)
            setBtnDisabled("none")
          }
          //不可以切换国家

          setIP(false)
        } else {
          //国外不校验不为空即可
          if (phoneNumberItem.length !== 0) {
            setClick(false)
            setBtnDisabled("auto")
          } else {
            setClick(true)
            setBtnDisabled("none")
          }
          setIP(true)
          // // 当前国家不是中国的时候过滤掉中国选项
          // setConvertCountryList(config.countryList.filter((type) => type.short !== "CN"))
        }
        config.countryList.map((item, index) => {
          if (item.short == simpleCountry) {
            setCode(item.tel)
            if (defaultLang === "zh") {
              setCountryAndArea(item.name)
            } else {
              setCountryAndArea(item.en)
            }
          }
        })
      }
    })
  }
  const notificationToast = (messageLoad) => {
    notification.open({
      message: messageLoad,
      duration: "2",
      bottom: "20px",
      maxCount: 0,
      placement: "bottomCenter",
      className: "custom-class",
      closeIcon: "",
      style: {
        width: 300,
        height: "auto",
      },
    })
  }

  const onClose = () => {
    setVisible(false)
  }

  //获取验证码
  const getPhoneCaptcha = () => {
    //校验不通过直接不让过
    if (btnDisabled === "none") {
      return
    }
    console.log(phoneNumber)
    //验证手机号是否输入或者是否正确,通过校验规则才开始倒计时,否则不发
    if (phoneNumber.length == 0) {
      notificationToast(allLang[lang].emptyPhone)
      return
    }

    //国家为china才校验手机号
    if (code == "86") {
      if (!phoneNumber.match(/^1(3\d|4[5-9]|5[0-35-9]|6[2567]|7[0-8]|8\d|9[0-35-9])\d{8}$/)) {
        notificationToast("手机号格式错误，请重新输入")
        return
      }
    }
    //发送请求
    let timeNow = new Date().getTime()
    let smsData = {
      phone: phoneNumber,
      phoneCode: code,
      timestamp: timeNow,
      lang: lang,
    }
    let encrypt = new JSEncrypt()
    encrypt.setPublicKey("-----BEGIN PUBLIC KEY-----" + publicKey + "-----END PUBLIC KEY-----")
    let encrypted = encrypt.encrypt(JSON.stringify(smsData))
    setIsGetCaptha(true)
    postJson(finalDomain + "oauth/smspublic", { data: encrypted })
      .then((res) => {
        if (res.success && !res.data.unregistered) {
          // 注意，不要使用 setTime(t-1) ： 闭包问题会导致time一直为59

          timeChange = setInterval(() => setTime((t) => --t), 1000)
          setBtnDisabled("none")
          saveCodeKey(res.data.codeKey)
          notificationToast(allLang[lang].sendSuccess)
        } else if (res.success && res.data.unregistered) {
          //手机号未注册 提示
          notificationToast(unregisteredresolve(lang))
          return
        } else {
          //处理后台返回的错误
          if (res && res.code) {
            // console.log(res)
            notificationToast(valicodeError(res.code, lang))
            return
          }
        }
      })
      .catch((error) => {
        //网络错误提示
        notificationToast(allLang[lang].sendFailure)
      })
  }
  const getQueryVariable = (variable) => {
    var query = window.location.search.substring(1)
    var vars = query.split("&")
    for (var i = 0; i < vars.length; i++) {
      var pair = vars[i].split("=")
      if (pair[0] == variable) {
        return pair[1]
      }
    }
    return false
  }
  //收取表单登录数据来登录(验证码和密码都是同一个接口)
  const onFinish = async (values) => {
    console.log("Success:", values)
    let fetchOptions

    if (!showAccount) {
      let bean = new FormData()
      let passwordEncrypt = new JSEncrypt()
      passwordEncrypt.setPublicKey(publicKey)
      let passwordEncrypted = encodeURIComponent(passwordEncrypt.encrypt(values.password))
      bean.append("grant_type", "password")
      bean.append("scope", "all")
      bean.append("type", "account")
      bean.append("signtype", "pk")
      bean.append("username", values.account)
      bean.append("password", passwordEncrypted)
      bean.append("clientId", clientId)
      if (clientIdList.includes(clientId)) {
        bean.append("country", country)
      } else {
        bean.append("country", initCountry)
      }
      bean.append("lang", lang)
      bean.append("response_type", "code")
      fetchOptions = {
        method: "POST",
        headers: {
          "Tenant-Id": "000000",
          Authorization: "Basic ZHJlYW1lX2FwcHYxOkFQXmR2QHpAU1FZVnhOODg=",
          mode: "cors",
          "Dreame-RLC": "d12671138cc6a559a275fea77a5a2383a68291663dbf8cad-1"
        },
        body: bean,
      }
    } else {
      if (!isGetCaptcha) {
        notificationToast(allLang[lang].getCodeFirst)
        return
      }
      let bean = new FormData()
      bean.append("grant_type", "sms")
      bean.append("scope", "all")
      bean.append("phone_code", code)
      bean.append("phone", values.phoneNumber)
      bean.append("clientId", clientId)
      bean.append("country", initCountry)
      bean.append("lang", lang)
      bean.append("response_type", "code")
      fetchOptions = {
        method: "POST",
        headers: {
          "Tenant-Id": "000000",
          "Sms-Code": values.valideCode,
          "Sms-Key": codeKey,
          Authorization: "Basic ZHJlYW1lX2FwcHYxOkFQXmR2QHpAU1FZVnhOODg=",
          mode: "cors",
          "Dreame-RLC": "d12671138cc6a559a275fea77a5a2383a68291663dbf8cad-1"
        },
        body: bean,
      }
    }

    try {
      let url = "" 
      if (clientIdList.includes(clientId)) {
        url = finalDomainSmarthome + "sh/api/auth/token"
      } else {
        url = finalDomain + "oauth/token"
      }
      const response = await fetch(url, fetchOptions)
      const res = await response.json()
      if (res.success) {
        let code = res.data
        
        // 如果提供了自定义登录成功回调，使用它而不是默认重定向
        if (onLoginSuccess) {
          onLoginSuccess(code)
          return
        }
        
        let url = decodeURIComponent(window.location.search)
        let finalUrl = ""
        let callbackUrl, callbackHttpUrl

        if (url.includes("aligenie")) {
          callbackUrl = url.replace("?redirect_uri=", "")
          callbackHttpUrl = callbackUrl.slice(0, callbackUrl.indexOf("?"))
          finalUrl = `${callbackHttpUrl}?`
          callbackUrl = callbackUrl.slice(callbackUrl.indexOf("?") + 1)
          callbackUrl.split("&").forEach((item) => {
            if (item.includes("skillId") || item.includes("state")) {
              finalUrl += `${item}&`
            }
            if (item.includes("token")) {
              finalUrl += `token=${encodeURIComponent(item.replace("token=", ""))}&`
            }
          })
          finalUrl += `code=${code}`
        } else if (url.includes("dueros")) {
          callbackUrl = url.split("redirect_uri=")[1]
          finalUrl = `${callbackUrl.split("&")[0]}?${callbackUrl.split("&").slice(1).join("&")}&code=${code}`
        } else if (url.includes("aqara") || url.includes("mihome") || url.includes("morelinks") || url.includes("google_mova") || url.includes("jdhome") || url.includes("alexa") || url.includes("vkplatform") || url.includes("leelen") || url.includes("moorgen") || url.includes("google") || url.includes("hornbach") || url.includes("hdl") || url.includes("iwith") || url.includes("chinaMobile")) {
          callbackUrl = url.split("redirect_uri=")[1]

          // 兼容旧逻辑：先尝试直接解码整个 callbackUrl
          let decodedRedirectUri
          let originalState = null
          let otherParams = [] 

          try {
            // 尝试直接解码整个 callbackUrl（旧逻辑）
            let directDecoded = decodeURIComponent(callbackUrl)
 
            if (directDecoded.indexOf("&") > -1) {
              // 如果包含 &，说明需要分离，使用新逻辑
              let redirectUriValue = callbackUrl
              let stateFromRedirectUri = null

              if (callbackUrl && callbackUrl.indexOf("&") > -1) {
                redirectUriValue = callbackUrl.slice(0, callbackUrl.indexOf("&"))
                let paramsAfterRedirectUri = callbackUrl.slice(callbackUrl.indexOf("&") + 1)
                paramsAfterRedirectUri.split("&").forEach((item) => {
                  if (item.includes("state=")) {
                    stateFromRedirectUri = item.replace("state=", "")
                  } else { 
                    otherParams.push(item)
                  }
                })
              }

              try {
                decodedRedirectUri = decodeURIComponent(redirectUriValue)
              } catch (e) {
                decodedRedirectUri = redirectUriValue
              }

              originalState = stateFromRedirectUri || getQueryVariable("state")
            } else {
              // 直接解码成功，但还需要检查原始 callbackUrl 是否包含 &（可能有其他参数）
              if (callbackUrl && callbackUrl.indexOf("&") > -1) {
                // 即使解码后没有 &，原始 URL 中可能还有编码的参数
                let redirectUriValue = callbackUrl.slice(0, callbackUrl.indexOf("&"))
                let paramsAfterRedirectUri = callbackUrl.slice(callbackUrl.indexOf("&") + 1)
                paramsAfterRedirectUri.split("&").forEach((item) => {
                  if (item.includes("state=")) {
                    originalState = item.replace("state=", "")
                  } else { 
                    otherParams.push(item)
                  }
                })
                try {
                  decodedRedirectUri = decodeURIComponent(redirectUriValue)
                } catch (e) {
                  decodedRedirectUri = redirectUriValue
                }
                if (!originalState) {
                  originalState = getQueryVariable("state")
                }
              } else {
                // 直接解码成功，使用旧逻辑的结果
                decodedRedirectUri = directDecoded
                originalState = getQueryVariable("state")
              }
            }
          } catch (e) {
            let redirectUriValue = callbackUrl
            let stateFromRedirectUri = null

            if (callbackUrl && callbackUrl.indexOf("&") > -1) {
              redirectUriValue = callbackUrl.slice(0, callbackUrl.indexOf("&"))
              let paramsAfterRedirectUri = callbackUrl.slice(callbackUrl.indexOf("&") + 1)
              paramsAfterRedirectUri.split("&").forEach((item) => {
                if (item.includes("state=")) {
                  stateFromRedirectUri = item.replace("state=", "")
                } else {
                  otherParams.push(item)
                }
              })
            }

            try {
              decodedRedirectUri = decodeURIComponent(redirectUriValue)
            } catch (e2) {
              decodedRedirectUri = redirectUriValue
            }

            originalState = stateFromRedirectUri || getQueryVariable("state")
          }

          finalUrl = `${decodedRedirectUri}?`
          if (originalState && originalState !== false) {
            finalUrl += `state=${encodeURIComponent(originalState)}&`
          }
          if (otherParams.length > 0) {
            finalUrl += otherParams.join("&") + "&"
          }
          finalUrl += `code=${code}`
        } else if (url.indexOf("alice") > -1 || url.indexOf("sber") > -1 || url.indexOf("google") > -1 || url.indexOf("google_mova") > -1 || url.indexOf("d_airp_dueros") > -1 || url.indexOf("d_airp_alice") > -1 || url.indexOf("d_airp_alexa") > -1 || url.indexOf("d_airp_google") > -1) {
          callbackUrl = url.split("redirect_uri=")
          // alert(callbackUrl, 'callbackUrl')
          if (Array.isArray(callbackUrl) && callbackUrl[1] && callbackUrl[0]) {
            if (callbackUrl[1].indexOf("?") == -1) {
              //alice授权需要拼接?
              let andSign = callbackUrl[1].indexOf("&")
              callbackHttpUrl = callbackUrl[1].substring(0, andSign) + "?" + callbackUrl[1].substring(andSign + 1)
            }

            if (callbackUrl[0].indexOf("?") != -1) {
              let fistPart = callbackUrl[0].indexOf("?")
              let urlState = callbackUrl[0].substring(fistPart + 1)
              let urlStateArray = urlState.split("&")
              urlStateArray.map((item, index) => {
                if (item.indexOf("state") > -1) {
                  let convertState = encodeURIComponent(item.replace("state=", ""))
                  callbackHttpUrl += "&" + `state=${convertState}`
                }
                if (item.indexOf("scope") > -1) {
                  callbackHttpUrl += "&" + item
                }
                // 为sber添加client_id和client_secret参数
                if (url.indexOf("sber") > -1) {
                  if (item.indexOf("client_id") > -1) {
                    callbackHttpUrl += "&" + item
                  }
                  if (item.indexOf("client_secret") > -1) {
                    callbackHttpUrl += "&" + item
                  }
                }
              })
            }
          }
          finalUrl = finalUrl + callbackHttpUrl
          finalUrl = finalUrl + `&code=${code}`
          // alert(finalUrl, 'finalUrl')
          window.location.href = finalUrl
        }
        window.location.href = finalUrl
      } else {
        const errorDescription = res.error_description || res.msg || res.message
        if (errorDescription && errorDescription !== "exceed max login attempts") {
          notificationToast(loginError(errorDescription, lang))
        } else if (errorDescription === "exceed max login attempts") {
          setVisible(true)
        }
      }
    } catch (error) {
      console.log(error)
    }
  }
  //账号
  const onChangeAccount = (e) => {
    setAccount(e.target.value)
    sessionStorage.setItem("account", e.target.value)
  }

  const onChangeCountry = (e) => {
    setCountry(e)
    sessionStorage.setItem("country", e)
  }

  //密码
  const onChangePassword = (e) => {
    setPassword(e.target.value)
    sessionStorage.setItem("password", e.target.value)
  }
  // 选择同意隐私协议
  const onChangeCheck = (e) => { 
    setCheckFile(e.target.checked) 
  }
  //切换登录方式
  const trigger = () => {
    setShowAccount(!showAccount) 
  }
  //输入手机号
  const onChangePhoneNumber = (e) => {
    if (IP) {
      //国外不校验不为空即可
      if (e.target.value.length !== 0) {
        setClick(false)
        setBtnDisabled("auto")
      } else {
        setClick(true)
        setBtnDisabled("none")
      }
    } else {
      //国内校验
      if (e.target.value.length === 11 && e.target.value.charAt(0) == 1) {
        setClick(false)
        setBtnDisabled("auto")
      } else {
        setClick(true)
        setBtnDisabled("none")
      }
    }

    setPhoneNumber(e.target.value)
    sessionStorage.setItem("phoneNumber", e.target.value)
  }
  //手机验证码
  const onChangeValideCode = (e) => {
    setValideCode(e.target.value)
    sessionStorage.setItem("valideCode", e.target.value)
  }

  const goback = () => {
    chooseAreaCode(!chooseArea)
  }

  const getCountrySource = () => {
    if (clientId === "d_airp_alexa") {
      return config.countryList.filter((item) => item.short !== "RU")
    }
    return config.countryList
  }

  const serachCountry = (e) => {
    //模糊查询国家
    let value = e.target.value
    const source = getCountrySource()
    setCountryList(value ? source.filter((type) => (type.en.toLocaleLowerCase()).includes(value.toLocaleLowerCase())) : source)
  }

  const serach = (e) => {
    //模糊查询国家
    let value = e.target.value
    // console.log(value)
    if (lang === "zh") {
      setConvertCountryList(value ? config.countryList.filter((type) => type.name.includes(value)) : config.countryList)
    } else {
      setConvertCountryList(value ? config.countryList.filter((type) => type.en.toUpperCase().includes(value.toUpperCase())) : config.countryList)
    }
  }

  const chooseSingalCountry = (e, item) => {
    //切换国家选择对应的code
    chooseAreaCode(!chooseArea)
    if (lang === "zh") {
      setCountryAndArea(item.name)
      //切换后对应的也要改
      setInitCountry(item.short)
    } else {
      setCountryAndArea(item.en)
      //切换后对应的也要改
      setInitCountry(item.short)
    }

    setCode(item.tel)
  }

  const afterLetter = (
    <span onClick={getPhoneCaptcha} style={{ pointerEvents: btnDisabled, color: isOnCliCK ? "#cccccc" : "rgba(0, 0, 0, 0.85)" }}>
      {btnContent || (lang ? allLang[lang].getCode : "")}
    </span>
  )

  const addonContainer = <span>+{code}</span>

  const cancelChooseLang = () => {
    setChooseLang(false)
  }
  const cancelChooseCountry = () => {
    setChooseCountry(false)
    setCountryList(getCountrySource())
  }
  const chooseOneLang = (e, item) => {
    setChooseLang(false);
    const selectedLang = item.value;
    setLang(selectedLang);
    sessionStorage.setItem("localLang", selectedLang);
    setBtnContent(allLang[selectedLang].getCode);

    const country = config.countryList.find(country => country.short === initCountry);
    if (country) {
      setCountryAndArea(selectedLang === "zh" ? country.name : country.en);
    }

    const voiceMap = {
      "aligenie": "cat",
      "dueros": "xiaodu",
      "aqara": "aqara",
      "alexa": "Alexa",
      "google": "google",
      "alice": "Alice",
      "d_airp_dueros": "d_airp_dueros",
      "d_airp_alice": "d_airp_alice",
      "d_airp_alexa": "d_airp_alexa",
      "d_airp_google": "d_airp_google",
      "sber": "sber",
      "moorgen": "moorgen",
      "vkplatform": "vk",
      "leelen": "leelen",
      "chinaMobile": "chinaMobile",
      "morelinks": "morelinks",
      "hornbach": "hornbach",
      "hdl": "hdl",
      "iwith": "iwith",
      "honor": "honor",
    };

    // 如果 clientId 是 honor，直接设置 voiceType
    if (clientId === "honor") {
      if (allLang[selectedLang] && allLang[selectedLang].honor) {
        setVoice(allLang[selectedLang].honor);
      } else {
        setVoice(allLang['en'].honor);
      }
    } else if (voiceMap[clientId]) {
      // 按 client_id 精确匹配，避免 d_airp_google 被较短的 google 命中后写成全小写
      setVoice(allLang[selectedLang][voiceMap[clientId]]);
    } else {
      const matchedKey = Object.keys(voiceMap)
        .sort((a, b) => b.length - a.length)
        .find((key) => pageUrl.includes(key))
      if (matchedKey) {
        setVoice(allLang[selectedLang][voiceMap[matchedKey]]);
      }
    }
  };

  const chooseOneCountry = (e, item) => {
    setChooseCountry(false)
    setCountry(item.short)
    setCountryList(getCountrySource())
  }

  const language = (lang) => {
    let oneLangguage
    switch (lang) {
      case "zh":
        oneLangguage = "中文简体"
        break
      case "en":
        oneLangguage = "English"
        break
      case "ru":
        oneLangguage = "русский"
        break
      case "zh-tw":
        oneLangguage = "繁體中文(台灣)"
        break
      case "zh-hk":
        oneLangguage = "繁體中文(香港)"
        break
      case "de":
        oneLangguage = "Deutsch"
        break
      case "ko":
        oneLangguage = "한국어"
        break
      case "ja":
        oneLangguage = "日本語"
        break
      case "fr":
        oneLangguage = "français"
        break
      case "es":
        oneLangguage = "español"
        break
      case "it":
        oneLangguage = "italiano"
        break
      case "pl":
        oneLangguage = "polski"
        break
      case "tr":
        oneLangguage = "Türkçe"
        break
      case "th":
        oneLangguage = "ไทย"
        break
      case "vi":
        oneLangguage = "Tiếng Việt"
        break
      case "id":
        oneLangguage = "Bahasa Indonesia"
        break
      case "uk":
        oneLangguage = "Українська Мова"
        break
      default:
        break
    }
    return <span>{oneLangguage}</span>
  }
  console.log(chooseCountry, chooseLang, lang, chooseArea, IP, "chooseCountry,chooseLang,lang")
  return (
    <div>
      {
        chooseCountry ? (
          <div className='chooseLangContainer'>
            <span onClick={cancelChooseCountry} className='leftStyle'>
              <LeftOutlined />
            </span>

            <div className='conutryList'>
              <Input
                placeholder={allLang[lang].select_location_tip}
                onChange={serachCountry}
                className="countrySearch"
              />
              {countryList.map((item, index) => {
                return (
                  <div className='singalConutry' key={index} onClick={(e) => chooseOneCountry(e, item)}>
                    {item.en}
                  </div>
                )
              })}
            </div>
          </div>
        ) :
          chooseLang && lang ? (
            <div className='chooseLangContainer'>
              <span onClick={cancelChooseLang} className='leftStyle'>
                <LeftOutlined />
              </span>
              <h2 className='langTitle'>{allLang[lang].chooseLang}</h2>

              <div className='langList'>
                {langList.map((item, index) => {
                  return (
                    <div className='singalLang' key={index} onClick={(e) => chooseOneLang(e, item)}>
                      {item.name}
                    </div>
                  )
                })}
              </div>
            </div>
          ) : chooseArea && lang && IP ? (
            <div className='search'>
              <div className='searchButton'>
                <span onClick={goback} className='leftStyle'>
                  <LeftOutlined />
                </span>{" "}
                <Input placeholder={allLang[lang].search} onChange={serach} />
              </div>
              <h1 className='countryAndArea'>{allLang[lang].region}</h1>

              <div className='countryList'>
                {converCountryList.map((item, index) => {
                  return (
                    item.short !== "CN" ?
                      <div className='singalArea' key={index} onClick={(e) => chooseSingalCountry(e, item)}>
                        {lang === "zh" ? item.name : item.en}
                      </div> : null
                  )
                })}
              </div>
            </div>
          ) : lang ? (
            <div className='App'>
              <div className='lang'>
                <div className='selectLang' onClick={changeLang}>
                  {language(lang)}&nbsp;&nbsp;
                  <DownOutlined />
                </div>
              </div>
              {/* {showAccount} */}
              {/* <Input id="account" allowClear placeholder={allLang[lang].phoneEmailId} className='account' onChange={onChangeAccount} value={account} /> */}
              <div className='logoDiv'>
                <img src={isAirpClient ? airpLogo : newLogo} alt='' className='logoImg'></img>
              </div>
              <div className='title'>
                <span className='titleName'>{isAirpClient ? allLang[lang].airpTitle : allLang[lang].title}</span>
              </div>
              <div className='loginForm'>
                <Row type='flex' justify='center' align='middle'>
                  <Col span={24}>
                    <Form name='basic' labelCol={{ span: 8 }} wrapperCol={{ span: 16 }} initialValues={{ remember: true }} onFinish={onFinish} form={form} autoComplete='off'>
                      {!showAccount ? (
                        <div>
                          {clientIdList.includes(clientId) ? (<Form.Item label='' name='country' wrapperCol={{ offset: 1, span: 8 }}>
                            <div>{country}&nbsp;&nbsp;
                              <DownOutlined onClick={() => setChooseCountry(true)} />
                            </div>
                          </Form.Item>) : null}
                          <Form.Item label='' name='account' rules={[{ required: true, message: allLang[lang].validPhoneEmailId }]}>
                            <Input id='account' allowClear placeholder={allLang[lang].phoneEmailId} className='account' onChange={onChangeAccount} value={account} />
                          </Form.Item>

                          <Form.Item label='' name='password' style={{ marginBottom: "15px" }} rules={[{ required: true, message: allLang[lang].password }]}>
                            <Input.Password placeholder={allLang[lang].password} className='password' value={password} onChange={onChangePassword} />
                          </Form.Item>

                          {clientIdList.includes(clientId) ? null : (<Form.Item wrapperCol={{ offset: 1, span: 8 }} style={{ marginBottom: "54px" }}>
                            <span className='phoneCode' onClick={trigger}>
                              {allLang[lang].codeLogin}
                            </span>
                          </Form.Item>)}
                        </div>
                      ) : (
                        <div>
                          <div className='selectCountry'>
                            <Form.Item wrapperCol={{ offset: 1, span: 8 }}>
                              <div className='select' onClick={chooseAreaCode}>
                                {countryAndArea}&nbsp;&nbsp;
                                <DownOutlined />
                              </div>
                            </Form.Item>
                          </div>

                          <Form.Item
                            label=''
                            name='phoneNumber'
                            //required: true, message: '请输入手机号码!'
                            rules={[{ required: true, message: allLang[lang].validPhoneNumer }]}
                          >
                            <Input style={{ height: "44px", borderRadius: "22px" }} addonBefore={addonContainer} placeholder={allLang[lang].phoneNumber} className='phoneNumber' allowClear onChange={onChangePhoneNumber} value={phoneNumber} />
                          </Form.Item>

                          <Form.Item label='' name='valideCode' rules={[{ required: true, message: allLang[lang].validCode }]}>
                            <Input style={{ height: "44px", borderRadius: "22px" }} addonAfter={afterLetter} placeholder={allLang[lang].code} className='valideCode' onChange={onChangeValideCode} value={valideCode} />
                          </Form.Item>

                          <Form.Item wrapperCol={{ offset: 1, span: 8 }} style={{ marginBottom: "54px" }}>
                            <span className='phoneCode' onClick={trigger}>
                              {allLang[lang].accountPasswordLogin}
                            </span>
                          </Form.Item>
                        </div>
                      )}
                      <Form.Item name='checkFile' wrapperCol={{ offset: 0, span: 8 }} className='checkboxChoose'>
                        <div>
                          {/* onClick={goGeneral} */}
                          <Checkbox checked={checkFile} onChange={onChangeCheck}></Checkbox>
                          <span className='normol'>&nbsp;&nbsp;{allLang[lang].pleaseCheck}</span>&nbsp;
                          <Link to={lang ? "/" + lang + "License" : ""} className='userSchedul'>
                            {allLang[lang].userShedule}
                          </Link>
                          &nbsp;<span className='normolAnd'>{allLang[lang].and}</span>&nbsp;
                          <Link to={lang ? "/" + lang + "Privacy" : ""} className='pricity'>
                            {allLang[lang].privary}
                          </Link>
                          <span className='normolAnd'>{allLang[lang].addtionnal}</span>
                          <div>
                            {/* 路由组件，注意这里path没有. */}

                            {/* <Route path='/enLicense' component={enLicense} /> */}
                          </div>
                        </div>
                      </Form.Item>

                      <Form.Item wrapperCol={{ offset: 0, span: 16 }} className='submitForm'>
                        <Button disabled={checkFile ? false : true} type='primary' htmlType='submit' className='submit'>
                          {allLang[lang].login}
                        </Button>
                      </Form.Item>

                      {voiceType !== "Amazon Alexa" ? (
                        <Form.Item wrapperCol={{ offset: 0, span: 16 }}>
                          <div className='agree'>
                            <div className='agreeTitle'>
                              <span className='agreeContent'>{allLang[lang].loginDescPart1}&nbsp;</span>
                              <span className='voiceType'>{voiceType}</span>&nbsp;<span className='agreeContent'>{allLang[lang].loginDescPart12}</span>
                            </div>
                          </div>
                        </Form.Item>
                      ) : (
                        ""
                      )}
                    </Form>
                  </Col>
                </Row>
              </div>
              <div className='drawStyle'>
                <Drawer title='' placement='bottom' onClose={onClose} visible={drawerVisible}>
                  <p className='knowContent' style={{ width: "80%", margin: "0 auto 20px" }}>
                    {allLang[lang].loginTryMany}
                  </p>
                  <div className='knowError'>
                    <Button type='primary' className='know' onClick={onClose}>
                      {allLang[lang].know}
                    </Button>
                  </div>
                </Drawer>
              </div>
            </div>
          ) : (
            ""
          )}
    </div>
  )
}

export default LoginForm
